import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { GenerativeCard } from "@/components/generative-ui/shared/GenerativeCard";
import type {
  SDRTemplatePreviewCard,
  CardActionHandler,
} from "@/components/generative-ui/envelope/types";

export interface Props {
  card: SDRTemplatePreviewCard;
  onAction?: CardActionHandler;
}

export function SDRTemplatePreviewView({ card, onAction }: Props) {
  return (
    <GenerativeCard.Root variant="default">
      <GenerativeCard.Header>
        <span className="text-xs uppercase tracking-wide text-pink-600">Template SDR</span>
        <span className="text-xs text-muted-foreground">· {card.specialty}</span>
      </GenerativeCard.Header>
      <GenerativeCard.Body>
        <div className="font-medium mb-2">{card.display_name}</div>
        <ul className="space-y-2">
          {card.sample_conversation.map((m, idx) => (
            <li
              key={idx}
              className={cn(
                "max-w-[85%] rounded-2xl px-3 py-2 text-sm",
                m.sender === "lead"
                  ? "bg-muted self-start"
                  : "bg-pink-100 self-end ml-auto",
              )}
            >
              {m.text}
            </li>
          ))}
        </ul>
      </GenerativeCard.Body>
      <GenerativeCard.Actions>
        <Button
          onClick={() =>
            onAction?.({
              intent: "clone_template",
              payload: { template_key: card.template_key },
            })
          }
        >
          Clonar template
        </Button>
      </GenerativeCard.Actions>
    </GenerativeCard.Root>
  );
}
